import { defineStore } from 'pinia';
import { computed } from 'vue';
import deepmerge from 'deepmerge';
import type confJson from '@/../public/appsettings.json';
import { removeTrailingSlash } from '@/utils/url';

export type WebConfiguration = typeof confJson;

export default defineStore('config', () => {
  let conf: undefined | WebConfiguration = undefined;

  const configuration = computed(() => {
    if (conf === undefined) {
      throw new Error(`The configuration is not initialized yet.`);
    }

    return conf;
  });
  
  async function loadConfiguration() {
    conf = (await (
      await fetch('/appsettings.json', {
        cache: 'no-cache',
      })
    ).json()) as WebConfiguration;

    if (import.meta.env.DEV) {
      // try to get dev config during dev
      const resp = await fetch('/appsettings.Development.json', {
        cache: 'no-cache',
      });

      if (resp.ok) {
        conf = deepmerge(conf, await resp.json());
      }
    }

    // format URIs
    conf.baseApiUrl = removeTrailingSlash(conf.baseApiUrl);
  }

  return {
    configuration,
    loadConfiguration,
  };
});
